import { graphql } from "../gql";

export const capabilitiesQueryDoc = graphql(`
  query capabilities($filter: [String!]) {
    capabilities(filter: $filter)
  }
`);
